import * as React from "react";
import { useState } from "react";
import { CardActionArea, CardContent, Paper, Typography, Tooltip, Button, CircularProgress, Box } from "@mui/material";
import Snackbar from '@mui/material/Snackbar';
import theme from "../../styles/theme";
import OpenInNewTab from '../../functions/new-tab'
import OpenInSameTab from '../../functions/change-tab'
import PropTypes from 'prop-types';

function ContactCard({ title, link, img, tool, handleClick}) {

  ContactCard.propTypes = {
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    img: PropTypes.element.isRequired,
    tool: PropTypes.string.isRequired,
    handleClick: PropTypes.func,
  };

  const [open, setOpen] = React.useState(false);
  const [pendingLink, setPendingLink] = useState(null);

  const handleClickOpen = () => {
    if (tool === "IGA") {
      setOpen(true);
      setPendingLink(link);
    } else {
      OpenInNewTab(link);
      if (handleClick) {
        handleClick();
      }
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    if (reason === 'timeout') {
      OpenInSameTab(pendingLink);
      if (handleClick) {
        handleClick();
      }
    }
    
    setOpen(false);
    setPendingLink(null);
  };

  const handleCancel = (event) => {
    event.stopPropagation(); 
    setOpen(false);
    setPendingLink(null);
  };

  return (
    <React.Fragment>
      <Paper
        borderRadius={3} 
        sx={{
          backgroundColor: "background.white",
          boxShadow: theme.palette.box.shadow,
        }}
      >
        <CardActionArea onClick={handleClickOpen}>
          <CardContent>
            {img}
            <Tooltip title={title}>
              <Typography
                variant="subtitle1"
                style={{
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  display: "-webkit-box",
                }}
              >
                {title}
              </Typography>
            </Tooltip>
          </CardContent>
        </CardActionArea>
      </Paper>

      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        message={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <CircularProgress size={20} color="inherit" />
            <span>Encaminhando para solicitação no IGA</span>
          </Box>
        }
        action={
          <Button color="secondary" size="small" onClick={handleCancel}>
            Cancelar
          </Button>
        }
      />
    </React.Fragment>
  );
}

export default ContactCard;